import { Container, ContainerProps } from '@mantine/core'
import React from 'react'

interface ICustomContainer extends ContainerProps {}
const ContentContainer = ({
    w = '100%',
    children,
    ...others
}: ICustomContainer) => {
    return (
        <Container
            maw={{ xs: '96%', sm: '100%', md: '90%', lg: '90%', xl: '1240px' }}
            w={w}
            px={{ xs: 'lg', sm: 50, md: 'xl' }}
            {...others}
        >
            {children}
        </Container>
    )
}

export default ContentContainer
